export * from './lib/sku-capsule-feature-sku-data.module';
